module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/join-online-only-6b4c78ab985f468e14f149abd9a23d79.png";